import { BaseApi } from './base-api.service';
import URL from '../../constants/api-constants';
import { generatePath } from 'react-router-dom';
import { CyclesCountResponse } from '../../types/cycle';

export class ContractService {
  private static readonly apiService = new BaseApi();

  static async getCyclesCount(contractId: string): Promise<CyclesCountResponse> {
    const path = generatePath(URL.CYCLES_COUNT_BY_CONTRACT, { contractId: contractId });

    const data = await this.apiService.api.get<CyclesCountResponse>(path);

    return data.data;
  }
}
